window.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const openCart = params.get("cart");
  if(openCart) {
    window.kachingCartApi.openCart();
  }
});